import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"php"}/>
}
